// Maps a product_key (matches entitlements.product_key in Supabase) to the
// Systeme.io funnel URL a locked feature's upgrade button should send the
// user to. Purchases there fire a webhook that grants the entitlement —
// there is no in-app checkout anymore.
//
// TODO: replace with the real shop.doctorgemma.com funnel URLs.
const upsells = {
  apps_premium: 'https://shop.doctorgemma.com/TODO-apps-premium-funnel',
};

export function getUpsellUrl(productKey) {
  return upsells[productKey] ?? 'https://shop.doctorgemma.com/';
}

export default upsells;
